import axios from 'axios';
import { installRequestDiagnostics } from './requestDiagnostics';

axios.defaults.withCredentials = true;
installRequestDiagnostics(axios);

export default axios;
